import { auth } from "@utils/firebase";
import { useGetUser } from "@utils/hooks";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const [user, userLoading] = useAuthState(auth);
  const { isLoading: isLoadingUserData } = useGetUser();
  if (userLoading || isLoadingUserData) {
    return <></>;
  } else {
    if (user) {
      if (!user.emailVerified) {
        return <Navigate to="/verify/email-verification" />;
      }
      return <Outlet />;
    } else {
      return <Navigate to="/entry" />;
    }
  }
};

export default ProtectedRoute;
